export const HIGHLIGHT_THRESHOLD = 0.886;
